"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSocialIconUtilityClass = getSocialIconUtilityClass;
exports.socialIconClasses = void 0;
var _base = require("@ori-ui/mui-bundle/base");
function getSocialIconUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriSocialIcon', slot);
}
const socialIconClasses = exports.socialIconClasses = (0, _base.generateUtilityClasses)('MuiOriSocialIcon', ['root', 'sizeMedium', 'sizeSmall', 'kindBlogger', 'kindDouban', 'kindEmail', 'kindFacebook', 'kindInstagram', 'kindLine', 'kindLink', 'kindMessenger', 'kindOdnoklassniki', 'kindPinterest', 'kindQq', 'kindQzone', 'kindRenren', 'kindRss', 'kindSignal', 'kindTelegram', 'kindTqq', 'kindTwitter', 'kindViber', 'kindVkontakte', 'kindWechat', 'kindWeibo', 'kindWhatsapp', 'kindX', 'kindYouku', 'kindYoutube', 'icon']);
var _default = exports.default = socialIconClasses;
//# sourceMappingURL=socialIconClasses.js.map